// assets
import { IconNotification, IconSettings, IconHistory } from '@tabler/icons';

// constant
const icons = {
    IconSettings: IconSettings,
    IconNotification: IconNotification,
    IconHistory: IconHistory,
};

//-----------------------|| SETTINGS MENU ITEMS ||-----------------------//

export const settings = {
    id: 'settings',
    title: 'Settings',
    type: 'group',
    roles: ['admin'], // Only show Settings group for admin role
    children: [
        {
            id: 'admin-list',
            title: 'Admins',
            type: 'item',
            url: '/admin-list',
            icon: icons['IconSettings'],
            breadcrumbs: false,
            roles: ['admin'],
        },
        {
            id: 'notification',
            title: 'Notification',
            type: 'item',
            url: '/notification',
            icon: icons['IconNotification'],
            breadcrumbs: false,
            roles: ['admin'],
        },
        {
            id: 'app-version',
            title: 'App Version',
            type: 'item',
            url: '/app-version',
            icon: icons['IconSettings'],
            breadcrumbs: false,
            roles: ['admin'],
        },
        {
            id: 'activity-log',
            title: 'Activity Log',
            type: 'item',
            url: '/activity-log',
            icon: icons['IconHistory'],
            breadcrumbs: false,
            roles: ['admin'],
        },
    ]
};